import { Api } from './api';

export class UserGuideApi extends Api {
    public async getUserGuide(filename: string): Promise<string> {
        return this.getFileAsync(`v1/userguide/${filename}`);
    }

    public constructor() {
        super();
    }
}
